/**
 * useDashboardWidgets — fetcha /api/dashboard/widgets para a métrica ativa.
 *
 * Retorna { data, loading, error } onde data = { metric, sources, devices, leadsGeo }.
 * Re-busca quando metric, período ou campaignIds mudam.
 */

import { useState, useEffect, useRef, useCallback } from 'react'
import { getDashboardWidgets, setSelectedClientId } from '../db/api.js'

export function useDashboardWidgets(startDate, endDate, campaignIds, clientId, metric) {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const requestIdRef = useRef(0)

  const campaignIdsKey = Array.isArray(campaignIds)
    ? campaignIds.slice().sort().join(',')
    : ''

  const refetch = useCallback(async () => {
    if (!startDate || !endDate) return
    const requestId = ++requestIdRef.current
    setLoading(true)
    setError(null)
    try {
      setSelectedClientId(clientId)
      const ids = campaignIdsKey ? campaignIdsKey.split(',') : []
      const result = await getDashboardWidgets(startDate, endDate, ids, metric)
      if (requestId !== requestIdRef.current) return
      setData(result)
    } catch (err) {
      if (requestId !== requestIdRef.current) return
      console.error('[useDashboardWidgets] fetch error:', err)
      setError(err.message || 'Erro ao carregar widgets')
    } finally {
      if (requestId === requestIdRef.current) setLoading(false)
    }
  }, [startDate, endDate, campaignIdsKey, clientId, metric])

  useEffect(() => { refetch() }, [refetch])

  return { data, loading, error, refetch }
}
